export default __webpack_public_path__ + "static/media/379.dd876be2.png";